export const RegexStrings= {
    nameRegex : /^[a-zA-Z. ]+$/,
    emptyRegex : /^\s*$/,
    phoneNumberRegex:/^[0-9]{10}$/
}